import React, { HTMLAttributes, PropsWithChildren, ReactNode, Ref, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldAlert, FieldAlertRef } from 'components/_new/FieldAlert';

export interface AutosaveIndicatorRef {
	show: () => void;
	hide: () => void;
}

export type AutosaveIndicatorProps = PropsWithChildren<
	Pick<HTMLAttributes<HTMLDivElement>, 'className'> & {
		message?: ReactNode;
		absolute?: boolean;
	}
>;

export const AutosaveIndicator = forwardRef(
	({ className, message, children, absolute = false }: AutosaveIndicatorProps, ref: Ref<AutosaveIndicatorRef>) => {
		const { t } = useTranslation();
		const content = message || children || t('misc.autosaveMessage');

		return (
			<FieldAlert
				ref={ref as Ref<FieldAlertRef>}
				className={className}
				message={content}
				absolute={absolute}
				variant="success"
				icon="check"
			/>
		);
	}
);
